import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    roofArea: number;
    mailParams: Record<string, string>;
};

type Dimensions = {
    width: number;
    height: number;
};

const USABLE_PERCENTAGE_OF_ROLL = 0.88;
const ROOFING_DIMENSIONS: Array<Dimensions> = [
    {
        width: 8,
        height: 1
    },
    {
        width: 6,
        height: 1
    }
];

const getRollArea = ({ width, height }: Dimensions) => width * height;
const getUsableRollArea = (dimensions: Dimensions) =>
    getRollArea(dimensions) * USABLE_PERCENTAGE_OF_ROLL;
const getAmountOfRollsNeeded = (roofArea: number, dimensions: Dimensions) =>
    Math.ceil(roofArea / getUsableRollArea(dimensions)).toFixed(0);

const Result = ({ roofArea, mailParams }: Props) => {
    const { t } = useGranite();

    const primer = roofArea / 5;
    const glue = roofArea;

    const amountOfRollsResultFields = ROOFING_DIMENSIONS.map((dimensions) => (
        <ResultField
            key={`${dimensions.width}-${dimensions.height}`}
            copy={
                t("calculator.roofingCalculator.amountOfRolls") +
                ` ${dimensions.width}m x ${dimensions.height}m`
            }
            value={getAmountOfRollsNeeded(roofArea, dimensions)}
            sm={12}
        />
    ));

    return (
        <div className={"mt-4"}>
            <ResultTitle mailParams={mailParams} />
            <Row>
                <ResultField
                    copy={t("calculator.roofingCalculator.roofArea")}
                    value={roofArea.toFixed(2)}
                    unit={"m"}
                    sup={2}
                    sm={8}
                    md={4}
                    lg={3}
                />
            </Row>
            <Row>
                <Col
                    sm={8}
                    md={4}
                    lg={3}
                >
                    <h4 className="d-sm-block">
                        {t("calculator.roofingCalculator.primerAndGlue")}
                    </h4>
                    <Row>
                        <ResultField
                            copy={t(
                                "calculator.roofingCalculator.volumePrimer"
                            )}
                            value={primer.toFixed(2)}
                            unit={"l"}
                            sm={12}
                        />
                        <ResultField
                            copy={t("calculator.roofingCalculator.volumeGlue")}
                            value={glue.toFixed(2)}
                            unit={"l"}
                            sm={12}
                        />
                    </Row>
                </Col>
                <Col
                    sm={8}
                    md={4}
                    lg={3}
                >
                    <h4 className="d-sm-block">
                        {t("calculator.roofingCalculator.underLayer")}
                    </h4>
                    <Row>{amountOfRollsResultFields}</Row>
                </Col>
                <Col
                    sm={8}
                    md={4}
                    lg={3}
                >
                    <h4 className="d-sm-block">
                        {t("calculator.roofingCalculator.roofing")}
                    </h4>
                    <Row>{amountOfRollsResultFields}</Row>
                </Col>
            </Row>
        </div>
    );
};

export default Result;
